import { render, staticRenderFns } from "./approveAdjustments.vue?vue&type=template&id=462ac429"
import script from "./approveAdjustments.vue?vue&type=script&lang=js"
export * from "./approveAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports